import { render, staticRenderFns } from "./ReconciliacaoIugu.vue?vue&type=template&id=f0c45cc8&"
import script from "./ReconciliacaoIugu.vue?vue&type=script&lang=js&"
export * from "./ReconciliacaoIugu.vue?vue&type=script&lang=js&"
import style0 from "./ReconciliacaoIugu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports